// Shared colour tokens for the exotics-pricer widgets.
//
// The MVP at immersive_gui/ui/src/index.css declares semantic CSS vars
// beyond what Diletta's theme exposes — notably the greek palette
// (delta = blue / accent, vega = purple, gamma = amber, theta sign-coloured).
//
// This module centralises those mappings against Diletta's theme so the
// widgets don't sprinkle one-off `chartsPurple` imports.

import { Theme } from '@mui/material';

import { chartsPurple, chartsOrange } from '../../../../theme/colors';

export type GreekKind = 'pv' | 'delta' | 'gamma' | 'theta' | 'vega';

// Resolve a greek's colour against the theme. PV and Theta callers should
// pass `sign` so the negative branch picks up the error colour; the others
// are sign-independent.
export const greekColour = (
  theme: Theme,
  kind: GreekKind,
  sign: 'positive' | 'negative' | null = null,
): string => {
  switch (kind) {
    case 'pv':
    case 'theta':
      return sign === 'negative'
        ? theme.palette.error.main
        : sign === 'positive'
          ? theme.palette.success.main
          : theme.palette.text.secondary;
    case 'delta':
      return theme.palette.primary.light;
    case 'gamma':
      // MVP semantic: gamma is neutral. Diletta accent is cyan; amber here
      // stands out as foreign. Neutral text colour matches both worlds.
      return theme.palette.text.primary;
    case 'vega':
      return chartsPurple;
  }
};

// Brand colour used in the modal header for the token name. The MVP uses
// orange (#f7931a); Diletta exposes chartsOrange (#F3733F). Close enough.
export const brandColour = chartsOrange;
